module.exports = "/assets/4dd0a05e7838a5a21b2a671854fd73e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ML.png
// module id = 2742
// module chunks = 0